module.exports = __webpack_public_path__ + "static/Jumpseller-dcf84aab3f90bc4bc3f7e827875425fd.svg";